var $2b6e161c9edcf319$exports = {};
const $2b6e161c9edcf319$var$bookmarkInput = document.getElementById("bookmarkInput"), $2b6e161c9edcf319$var$bookmarkButton = document.getElementById("addBookmarkBtn"), $2b6e161c9edcf319$var$bookmarkList = document.getElementById("bookmarkList");
// localStorage.clear();
let $2b6e161c9edcf319$var$sessionBookmarksArray = !localStorage.bookmarks ? [] : JSON.parse(localStorage.bookmarks);
console.log(localStorage.bookmarks);
function $2b6e161c9edcf319$var$bookmarksRefresh() {
    localStorage.bookmarks = JSON.stringify($2b6e161c9edcf319$var$sessionBookmarksArray);
    $2b6e161c9edcf319$var$bookmarkList.innerHTML = "";
    $2b6e161c9edcf319$var$sessionBookmarksArray.forEach((url)=>{
        $2b6e161c9edcf319$var$bookmarkList.innerHTML += `<li><a href="${url}" target="_blank">${url}</a><button class="delete">X</button></li>`;
    });
}
$2b6e161c9edcf319$var$bookmarksRefresh();
$2b6e161c9edcf319$var$bookmarkButton.addEventListener("click", ()=>{
    const newUrl = $2b6e161c9edcf319$var$bookmarkInput.value;
    if (newUrl === "") return;
    $2b6e161c9edcf319$var$sessionBookmarksArray.push(newUrl);
    $2b6e161c9edcf319$var$bookmarksRefresh();
});
$2b6e161c9edcf319$var$bookmarkList.addEventListener("click", (event)=>{
    const button = event.target;
    if (!button.classList.contains("delete")) return;
    const url = button.parentElement.querySelector("a").textContent;
    $2b6e161c9edcf319$var$sessionBookmarksArray = $2b6e161c9edcf319$var$sessionBookmarksArray.filter((element)=>element !== url);
    $2b6e161c9edcf319$var$bookmarksRefresh();
});
const $2b6e161c9edcf319$var$usernameInput = document.getElementById("username"), $2b6e161c9edcf319$var$passwordInput = document.getElementById("password"), $2b6e161c9edcf319$var$saveButton = document.getElementById("saveBtn");
if (localStorage.username !== undefined) $2b6e161c9edcf319$var$usernameInput.value = localStorage.username;
if (localStorage.password !== undefined) $2b6e161c9edcf319$var$passwordInput.value = localStorage.password;
$2b6e161c9edcf319$var$saveButton.addEventListener("click", ()=>{
    localStorage.username = $2b6e161c9edcf319$var$usernameInput.value;
    localStorage.password = $2b6e161c9edcf319$var$passwordInput.value;
});


//# sourceMappingURL=JavaScript8-2.7be35204.js.map
